// Delete this file when removing Features.DisablePageLoadStats
// TODO PP-16776: move LoggedInWeb/utils/page-loading-stats here once we complete webpack LoggedInWeb migration

export * from '../../LoggedInWeb/utils/page-loading-stats';
